import {
  AvailablePreTestConfigurationOptions,
  AvailableOMSpecificConfigurationOptions,
  TestConfiguration,
  TestType,
} from "types/testTypes";
import { availableOcularMotilityTestConfigurationOptions } from "@constants/testConstants/testSpecificConstants";
import { AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS_ENGLISH_ONLY } from "@constants/testConstants/configurationHelperConstants";
import { cloneDeep } from "lodash";

// Test-specific options that only apply to one OM test type; every other
// type has them stripped from its available configuration.
const TEST_SPECIFIC_OPTION_OWNERS: Partial<
  Record<keyof AvailableOMSpecificConfigurationOptions, TestType>
> = {
  trialCountOptions: TestType.AntiSaccades,
  toggleChildMode: TestType.SmoothPursuit,
};

export function GetUpdatedAvailableOMConfigsAfterConfigUpdate(
  requestedUpdate: Partial<TestConfiguration>,
  baseOptions?: AvailablePreTestConfigurationOptions | null,
): AvailablePreTestConfigurationOptions {
  const availableOMConfig: AvailablePreTestConfigurationOptions = cloneDeep(
    baseOptions ?? availableOcularMotilityTestConfigurationOptions,
  );

  const specificOptions =
    availableOMConfig.testSpecificConfigurationOptions as AvailableOMSpecificConfigurationOptions;
  for (const [optionKey, ownerTestType] of Object.entries(TEST_SPECIFIC_OPTION_OWNERS)) {
    if (ownerTestType !== requestedUpdate.testType) {
      delete specificOptions[optionKey as keyof AvailableOMSpecificConfigurationOptions];
    }
  }

  if (requestedUpdate.testType === TestType.AntiSaccades) {
    // Anti-saccade only ships an English instruction video, so its virtual
    // assistant must not offer the full language list other OM tests use.
    availableOMConfig.virtualAssistantOptions = {
      ...AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS_ENGLISH_ONLY,
    };
  }

  return availableOMConfig;
}
